/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetAnimationsResult } from '../../models/get-animations-result';

export interface GetAnimations$Params {
  SiteName?: string;
  PageIndex?: number;
  PageSize?: number;
}

export function getAnimations(
  http: HttpClient,
  rootUrl: string,
  params?: GetAnimations$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<GetAnimationsResult>> {
  const rb = new RequestBuilder(rootUrl, getAnimations.PATH, 'get');
  if (params) {
    rb.query('SiteName', params.SiteName, {});
    rb.query('PageIndex', params.PageIndex, {});
    rb.query('PageSize', params.PageSize, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetAnimationsResult>;
    }),
  );
}

getAnimations.PATH = '/Restaurants/animations';
